const RECAPTCHA_CHALLENGE_CODE = "RECAPTCHA_CHALLENGE_REQUIRED";
const RECAPTCHA_V2_FAILED_CODE = "RECAPTCHA_VERIFICATION_FAILED";

export function parseLoginErrorMeta(data, status) {
    if (typeof data === "string") {
        return { status, detail: data };
    }

    if (!data || typeof data !== "object") {
        return { status };
    }

    return {
        status,
        code: data.code,
        error_code: data.error_code,
        message: data.message,
        detail: data.detail,
        requires_recaptcha_v2: data.requires_recaptcha_v2
    };
}

export function isRecaptchaChallengeError(errorMeta) {
    if (errorMeta?.status !== 403) return false;
    return (
        errorMeta.requires_recaptcha_v2 === true ||
        errorMeta.code === RECAPTCHA_CHALLENGE_CODE ||
        errorMeta.error_code === RECAPTCHA_CHALLENGE_CODE
    );
}

export function isRecaptchaV2FailedError(errorMeta) {
    if (errorMeta?.status !== 403) return false;
    return (
        errorMeta.code === RECAPTCHA_V2_FAILED_CODE ||
        errorMeta.error_code === RECAPTCHA_V2_FAILED_CODE
    );
}

export function getLoginErrorMessage(error, errorMeta) {
    return errorMeta?.message || errorMeta?.detail || error || "Login Failed!";
}
